@if (remote.isNotAsked() && notAskedTemplate) {
  <ng-container *ngTemplateOutlet="notAskedTemplate" />
}
@if (remote.isLoading()) {
  <ng-container *ngTemplateOutlet="loadingTemplate" />
}
@if (remote.isFailure()) {
  <ng-container *ngTemplateOutlet="failureTemplate; context: { $implicit: asFailure(remote)._error }" />
}
@if (remote.isSuccess()) {
  @if (!isEmpty(asSuccess(remote)._data)) {
    <ng-container *ngTemplateOutlet="successTemplate; context: { $implicit: asSuccess(remote)._data }" />
  } @else {
    <ng-container *ngTemplateOutlet="emptyTemplate; context: { $implicit: asSuccess(remote)._data }" />
  }
}
